import { createContext } from 'react'
import { ArticleType } from '@widgets/Teaser/standard/types'
import { TeaserFlexValueDesktop } from '@widgets/Teaser/types'

export interface StandardTeaserLayoutContextType {
  accentColor: string
  articleType: ArticleType
  hasExtraLargeTabletStyle: boolean
  hasMiniDesktopStyle: boolean
  hasVideoOnlyStyle: boolean
  isInMegaModule: boolean
  isPromo: boolean
  isVideoOnly: boolean
  teaserFlex: TeaserFlexValueDesktop
}

const StandardTeaserLayoutContext =
  createContext<StandardTeaserLayoutContextType>({
    accentColor: '',
    articleType: 'default',
    hasExtraLargeTabletStyle: false,
    hasMiniDesktopStyle: false,
    hasVideoOnlyStyle: false,
    isInMegaModule: false,
    isPromo: false,
    isVideoOnly: false,
    teaserFlex: '2',
  })

const exports = { StandardTeaserLayoutContext }

export default exports
